export default "__VITE_PUBLIC_ASSET__979e939c__"